import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchSuppliers } from '@/api';
import { AddInvoiceForm } from '@/components/suppliers/AddInvoiceDialog';
import type { Supplier } from '@/types/supplier';
import { toast } from 'sonner';

export default function SupplierInvoiceNewPage() {
  const navigate = useNavigate();
  const [suppliers, setSuppliers] = useState<Supplier[]>([]);

  useEffect(() => {
    document.title = 'New Supplier Invoice - Vixalor';
  }, []);

  useEffect(() => {
    fetchSuppliers()
      .then((response) => setSuppliers(response.data || []))
      .catch(() => toast.error('Failed to load suppliers'));
  }, []);

  const goBack = () => navigate('/suppliers', { state: { tab: 'invoices' } });

  return (
    <div className="space-y-6 animate-fade-in">
      <AddInvoiceForm
        suppliers={suppliers}
        onSuccess={goBack}
        onCancel={goBack}
      />
    </div>
  );
}
